(function organizationalUnitAddControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitAddController', [
            '$scope', 'config', '$state', '$translate', '$filter', 'errorsExtend', 'adminOrganizationalUnitService', 'authExtend', 'themeService', 'storageTypeService', 'processTypeService', 'configViewService', 'organizationalUnitService', 'metadataService', 'securityLevelConfigService',
            'ui', '$interval', 'organizationalUnitConfigService', '$q', 'Upload',
            function organizationalUnitAddController($scope, config, $state, $translate, $filter, errors, adminOrganizationalUnitService, authExtend, themeService, storageTypeService, processTypeService, configViewService, organizationalUnitService, metadataService, securityLevelConfigService,
                ui, $interval, organizationalUnitConfigService, $q, Upload) {
                $scope.hideDependOuDrop = !authExtend.isInRole('ORGANIZATIONALUNIT CREATE');
                $scope.securityLevelAccordionOpened = true;

                $scope.openSecurityLevelAccordion = function () {
                    $scope.securityLevelAccordionOpened = !$scope.securityLevelAccordionOpened;
                };

                // mapea un OrganizationalUnitConfigMetadata a un value.
                var mapOuConfigMetadataToValue = function (ouConfig, ouConfigMetadata) {
                    var optionsObject = ouConfigMetadata.metadata.properties.find(function (prop) {
                        return prop.property.name === 'options';
                    });

                    var metadataOptions = (optionsObject) ? optionsObject.value : null;

                    return {
                        idObject: ouConfig.id + '' + ouConfigMetadata.metadata.id,
                        metadataId: ouConfigMetadata.metadata.id,
                        metadataIsRequired: ouConfigMetadata.isRequired,
                        metadataIsUnique: ouConfigMetadata.isUnique,
                        metadataReadOnly: false,
                        metadataMinDate: ouConfigMetadata.metadata.systemName == '#FecV' ? new Date() : undefined,
                        metadataValue: '',
                        metadataType: ouConfigMetadata.metadata.metadataType.name,
                        metadataLabel: ouConfigMetadata.metadata.name,
                        metadataOptions: metadataOptions,
                        metadataEnabled: ouConfigMetadata.isEnabled,
                        metadataPosition: ouConfigMetadata.position,
                        // utilizado para reconstruir el valor
                        organizationalUnitConfigMetadata: ouConfigMetadata
                    }
                };

                var ouOuConfigMetadataValueFromUiValue = function (ou) {

                    angular.forEach(ou.configs, function (ouOuConfig) {

                        ouOuConfig.metadataValues = ouOuConfig.metadataValues.map(function (ouMetadata) {
                            if (ouMetadata.originalValueObject) {
                                ouMetadata.originalValueObject.value = ouMetadata.metadataValue;
                                return ouMetadata.originalValueObject;
                            }
                            // si no tiene objeto original entonces hay que crearlo
                            return {
                                // es un ouOuConfigMetadataValue
                                value: ouMetadata.metadataValue,
                                organizationalUnitConfigMetadata: ouMetadata.organizationalUnitConfigMetadata
                            };
                        });
                    });
                };

                $scope.loadStorageType = function () {

                    if ($scope.ou.parentOrganizationalUnitId > 0) {
                        adminOrganizationalUnitService.getById($scope.ou.parentOrganizationalUnitId)
                            .then(function (ou) {
                                $scope.ou.isRoot = false;
                                $scope.ou.storageTypeId = ou.storageTypeId;
                            }, function (error) {
                                errors.showError(error);
                            });

                    } else {
                        $scope.ou.isRoot = true;
                    }
                };

                // cargará los tipos asignables 
                $scope.getAssignableConfigs = function () {
                    organizationalUnitConfigService.getAll(true, null, $scope.ou.parentOrganizationalUnitId)
                        .then(function (ous) {

                            $scope.aux.optionsOuConfigs = ous;

                            // agrego los ou configs actuales a los seleccionados
                            $scope.aux.selectedOuConfigs = $scope.aux.optionsOuConfigs.filter(function (config) {
                                return ($scope.ou.configs.findIndex(function (ouOuConfig) {
                                    return ouOuConfig.organizationalUnitConfig.id === config.id;
                                }) !== -1);
                            });

                            // remuevo los configs de la ou que no están disponibles para seleccionar
                            for (var i = 0; i < $scope.ou.configs.length; i++) {

                                var ouOuConfig = $scope.ou.configs[i];
                                var index = $scope.aux.optionsOuConfigs.findIndex(function (config) {
                                    return ouOuConfig.organizationalUnitConfig.id === config.id;
                                });

                                if (index === -1) {
                                    $scope.ou.configs.splice(index, 1);
                                    i--;
                                }
                            }

                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                };

                var backTheme,
                    fileUploadInfo = null,
                    fileStartImageInfo = null;

                var resetFileUpload = function resetFileUploadFn() {
                    fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                var resetfileStartImageInfo = function resetfileStartImageInfoFn() {
                    fileStartImageInfo = $scope.fileStartImageInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                $scope.load = function () {
                    $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);

                    $translate(['OUAdd']).then(function (translated) {
                        $scope.title = translated.OUAdd;
                    });

                    $scope.ou = {
                        name: '',
                        themeId: undefined,
                        isRoot: true,
                        storageTypeId: 1,
                        parentOrganizationalUnitName: authExtend.getOrganizationName(),
                        parentOrganizationalUnitId: authExtend.getOrganizationId(),
                        configs: []
                    };

                    $scope.requiredOu = authExtend.getOrganizationId() ? true : false;
                    $scope.myOu = false;

                    $scope.aux = {
                        optionsThemes: [],
                        selectedOuConfigs: [],
                        optionsOuConfigs: [],
                        optionsStorageTypes: []
                    };

                    $scope.parameters = {
                        notInOuId: ''
                    };

                    securityLevelConfigService.get()
                        .then(function (slcs) {
                            $scope.aux.optionsSelectLevelConfig = slcs;
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });

                    themeService.get().then(function (result) {
                        $scope.aux.optionsThemes = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });

                    $scope.getAssignableConfigs();
                    resetFileUpload();
                    resetfileStartImageInfo();

                    $scope.$watch("ou.parentOrganizationalUnitId", $scope.loadStorageType);

                    storageTypeService.get(null, null).then(function (result) {
                        $scope.aux.optionsStorageTypes = result;

                        $scope.showStorageTypes = true;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });

                };

                // Mapeo los metadatos para que los entiendan los controles
                $scope.addOuConfig = function (ouConfig) {
                    var config = {
                        metadataValues: ouConfig.metadata.map(function (ouConfigMetadata) {
                            return mapOuConfigMetadataToValue(ouConfig, ouConfigMetadata);
                        }),
                        organizationalUnitConfig: ouConfig
                    };

                    config.metadataValues.sort(function (a, b) {
                        return a.metadataPosition - b.metadataPosition;
                    });

                    $scope.ou.configs.push(config);
                };

                $scope.selectOuConfig = function (ouConfig) {
                    organizationalUnitConfigService.getById(ouConfig.id)
                        .then(function (result) {
                            $scope.addOuConfig(result);
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                };

                $scope.removeOuConfig = function (ouConfig) {

                    var indexOf = $scope.ou.configs.findIndex(function (config) {
                        return (config.organizationalUnitConfig.id === ouConfig.id);
                    });

                    if (indexOf !== -1) {
                        $scope.ou.configs.splice(indexOf, 1);
                    }
                };

                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('image') > -1) {

                        if (fileUploadInfo.promise !== null) {
                            fileUploadInfo.promise.abort();
                            fileUploadInfo.promise = null;
                        }
                        fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        fileUploadInfo.selectedFile = Upload.rename(files[0], 'logo_' + files[0].name);

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.onFileStartImageSelect = function startImageSelect(files) {
                    if (files && files.length && files[0].type.indexOf('image') > -1) {

                        if (fileStartImageInfo.promise !== null) {
                            fileStartImageInfo.promise.abort();
                            fileStartImageInfo.promise = null;
                        }
                        fileStartImageInfo.progress = -1;

                        // me interesa solo un archivo
                        fileStartImageInfo.selectedFile = Upload.rename(files[0], 'startImage_' + files[0].name);

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileStartImageInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.previewTheme = function () {
                    var theme = null;

                    for (var i = 0; $scope.aux.optionsThemes.length > i; i++) {
                        if ($scope.aux.optionsThemes[i].id === $scope.ou.themeId) {
                            theme = $scope.aux.optionsThemes[i].path;
                        }
                    }

                    if (angular.isDefined(backTheme)) {
                        $interval.cancel(backTheme);
                    }
                    backTheme = $interval(function () {
                        authExtend.getTheme();
                        ui.setTheme(null);
                        $interval.cancel(backTheme);
                    }, 1500);

                    ui.setTheme(theme);
                }

                var associateProcessType = function (ou) {
                    $q.all([processTypeService.getProcessTypeByOuId(ou.id, 'Documentos'),
                    processTypeService.getProcessTypeById(9),
                    metadataService.get({ systemName: '_tipoDoc', global: true })])
                        .then(function (result) {
                            var processType = result[0].value[0];
                            var genericProcessType = result[1].value;
                            var metadata = result[2][0];
                            metadata.organizationUnitId = ou.id;
                            metadata.organizationUnitName = ou.name;

                            metadataService.create(metadata).then(function (metadata) {
                                var customMetadata = {
                                    metadataId: metadata.value.id,
                                    metadataName: metadata.value.name,
                                    metadataSystemName: metadata.value.systemName,
                                    metadataType: metadata.value.type,
                                    metadataOptionValues: metadata.value.optionValues
                                };

                                if (!processType) {
                                    processType = {
                                        organizationalUnitId: ou.id,
                                        organizationalUnitName: ou.name,
                                        name: genericProcessType.name,
                                        isEnabled: true,
                                        metadatas: genericProcessType.metadatas
                                    };

                                    processType.metadatas.push(customMetadata);

                                    processTypeService.createProcessType(processType).then(function (result) {
                                        $scope.updateConfig(result.value, customMetadata);
                                    }, function (error) {
                                        errors.showError(error);
                                        $state.go('organizational-unit-find');
                                    });
                                } else {
                                    processType.id = undefined;
                                    processType.metadatas.push(customMetadata);

                                    $scope.updateConfig(processType, customMetadata);
                                }
                            });
                        }, function (error) {
                            errors.showError(error);
                            $state.go('organizational-unit-find');
                        });
                };

                $scope.updateConfig = function (processType, metadata) {
                    $q.all([configViewService.getById('CPPDocument'), configViewService.getById('CPPDocumentRRHH')])
                        .then(function (result) {
                            var documentConfigView = result[0];
                            var documentRRHHConfigView = result[1];
                            var documentProcessType = angular.copy(documentConfigView.processTypes[0]);
                            var documentRRHHProcessType = angular.copy(documentRRHHConfigView.processTypes[0]);

                            documentProcessType.order = Math.max.apply(Math, documentConfigView.processTypes.map(function (p) { return p.order; })) + 1;
                            documentProcessType.processTypeId = processType.id;
                            documentRRHHProcessType.order = Math.max.apply(Math, documentRRHHConfigView.processTypes.map(function (p) { return p.order; })) + 1;
                            documentRRHHProcessType.processTypeId = processType.id;

                            var metadataConfigView = $filter('filter')(documentProcessType.metadatas, function (item) { return item.systemName === '_tipoDoc' })[0];
                            var metadataRRHHConfigView = $filter('filter')(documentRRHHProcessType.metadatas, function (item) { return item.systemName === '_tipoDoc' })[0];

                            if (metadataConfigView && !metadataRRHHConfigView) {
                                metadataConfigView.metadataId = metadata.metadataId
                                metadataRRHHConfigView = angular.copy(metadataConfigView);
                            } else if (!metadataConfigView && metadataRRHHConfigView) {
                                metadataRRHHConfigView.metadataId = metadata.metadataId
                                metadataConfigView = angular.copy(metadataRRHHConfigView);
                            } else if (metadataConfigView && metadataRRHHConfigView) {
                                metadataConfigView.metadataId = metadata.metadataId
                                metadataRRHHConfigView.metadataId = metadata.metadataId
                            } else {
                                metadataConfigView = {
                                    metadataId: metadata.metadataId,
                                    systemName: metadata.metadataSystemName,
                                    metadataOptionValues: metadata.metadataOptionValues,
                                    metadataType: metadata.metadataType,
                                    detailCriteria: { name: metadata.metadataName, order: 10 },
                                    resultCriteria: { name: metadata.metadataName, order: 10 },
                                    searchCriteria: { name: metadata.metadataName, order: 10 },
                                };

                                metadataRRHHConfigView = angular.copy(metadataConfigView);
                                metadataRRHHConfigView.createCriteria = { isEditable: true, isRequired: true, name: metadata.metadataName, order: 10 };
                                documentProcessType.metadatas.push(metadataConfigView);
                                documentRRHHProcessType.metadatas.push(metadataRRHHConfigView);
                            }

                            documentConfigView.processTypes.push(documentProcessType);
                            documentRRHHConfigView.processTypes.push(documentRRHHProcessType);

                            $q.all([
                                configViewService.update(documentConfigView),
                                configViewService.update(documentRRHHConfigView),
                                processTypeService.addProcessTypeToWorkflow(processType.id, 'WF Documentos')
                            ]).then(function (result) {
                                $state.go('organizational-unit-find');
                            }, function (error) {
                                console.log(error);
                                errors.showError('ProcessTypeAssociateFailed');
                                $state.go('organizational-unit-find');
                            });
                        });
                };

                $scope.save = function save() {
                    var startImage = false,
                        iconImage = false,
                        auxFiles = [];

                    if (!$scope.organizationalUnitForm.$valid) {
                        errors.showError('VerifyFormData');
                        return;
                    }

                    if (fileUploadInfo.promise !== null) {
                        fileUploadInfo.promise.abort();
                        fileUploadInfo.promise = null;
                    }

                    if (fileUploadInfo.selectedFile) {
                        auxFiles.push(fileUploadInfo.selectedFile);
                        iconImage = true;
                    }

                    if (fileStartImageInfo.promise !== null) {
                        fileStartImageInfo.promise.abort();
                        fileStartImageInfo.promise = null;
                    }

                    if (fileStartImageInfo.selectedFile) {
                        auxFiles.push(fileStartImageInfo.selectedFile);
                        startImage = true;
                    }

                    $scope.ou.securityLevelConfig = $filter('filter')($scope.aux.optionsSelectLevelConfig, { id: $scope.ou.selectedSecurityLevel }, true)[0];

                    var ou = angular.copy($scope.ou);

                    ouOuConfigMetadataValueFromUiValue(ou);

                    return adminOrganizationalUnitService.create(ou, auxFiles, iconImage, startImage)
                        .then(function (result) {
                            organizationalUnitService.getTreeOf(result.data.entityId).then(function (result) {
                                if (!result[0].parentOrganizationalUnitId) {
                                    associateProcessType(result[0]);
                                } else {
                                    $state.go('organizational-unit-find');
                                }
                            });
                            ;
                        },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.removeStartImage = function () {
                    $scope.ou.urlStartImage = null;
                    resetfileStartImageInfo();
                }

                $scope.removeIcon = function () {
                    $scope.ou.urlIcon = null;
                    resetFileUpload();
                }

                $scope.cancel = function () {
                    $state.go('organizational-unit-find');
                };

                $scope.load();
            }
        ]);
})();
